import { TimetablePrintColorOrigins } from '@bp/planung-graphql-types';
import { _TimetablePrintConfigQuery, TimetableReportType } from '../../types/planung-graphql-client-defs';
import { timetablePrintColorDefaults, timetablePrintLayoutDefaults } from '../../utils/printDefaults';
import { TimetablePrintBaseData, TimetablePrintLayoutData } from './forms/TimetablePrintConfigurationForm';

export const useGetInitialTimetablePrintConfig = ({
  subType,
  current,
}: {
  subType: TimetableReportType;
  current?: _TimetablePrintConfigQuery['timetablePrintConfig'];
}) => {
  const subjectColor = '#C0CEF2';
  const teacherColor = '#F2C1C0';
  const roomColor = '#C8F2C0';
  const classColor = '#FAECB9';
  const white = '#f7f7f7';

  const colorDefaults = timetablePrintColorDefaults[subType];
  const layoutDefaults = timetablePrintLayoutDefaults[subType];

  function getInitialColor(from: TimetablePrintColorOrigins | null): string {
    switch (from) {
      case TimetablePrintColorOrigins.Room:
        return roomColor;
      case TimetablePrintColorOrigins.Subject:
        return subjectColor;
      case TimetablePrintColorOrigins.Teacher:
        return teacherColor;
      case TimetablePrintColorOrigins.Class:
        return classColor;
      case TimetablePrintColorOrigins.None:
        return white;
      default:
        return subjectColor;
    }
  }

  const initialBaseData: TimetablePrintBaseData = {
    color: getInitialColor(current?.printColorOrigin ?? null),
    colorPosition: current?.printColorPosition ?? colorDefaults.colorPosition,
    colorOrigin: current?.printColorOrigin ?? colorDefaults.colorOrigin,
    printClasses: current?.printClasses ?? colorDefaults.printClasses,
    scaleText: current?.scaleText ?? colorDefaults.scaleText,
    exactMinute: current?.exactMinute ?? colorDefaults.exactMinute,
    printSubtitle: current?.printSubtitle ?? colorDefaults.printSubtitle,
    printLogo: current?.printLogo ?? colorDefaults.printLogo,
    largeFont: current?.largeFont ?? colorDefaults.largeFont,
    showSchoolWeeks: current?.showSchoolWeeks ?? colorDefaults.showSchoolWeeks,
    showCalendarWeeks: current?.showCalendarWeeks ?? colorDefaults.showCalendarWeeks,
    showWeekSchoolDays: current?.showWeekSchoolDays ?? colorDefaults.showWeekSchoolDays,
    timeHorizontal: current?.timeHorizontal ?? colorDefaults.timeHorizontal,
    epochGridOwnPage: current?.epochGridOwnPage ?? colorDefaults.epochGridOwnPage,
    responsiblePersonNameFormat: current?.responsiblePersonNameFormat ?? colorDefaults.responsiblePersonNameFormat,
  };

  const initialLayoutData: TimetablePrintLayoutData = {
    bottomCenter: current?.bottomCenter ?? layoutDefaults.bottomCenter,
    bottomLeft: current?.bottomLeft ?? layoutDefaults.bottomLeft,
    bottomRight: current?.bottomRight ?? layoutDefaults.bottomRight,
    center: current?.center ?? layoutDefaults.center,
    topLeft: current?.topLeft ?? layoutDefaults.topLeft,
    topCenter: current?.topCenter ?? layoutDefaults.topCenter,
    topRight: current?.topRight ?? layoutDefaults.topRight,
  };

  return { initialBaseData, initialLayoutData };
};
